export default class MessageAppForm {
  constructor (data) {
    this.id = data.id;
    this.name = data.name;
    this.remark = data.remark;
    this.createdBy = data.createdBy;
    this.createdat = data.createdat;
    this.updatedBy = data.updatedBy;
    this.updatedAt = data.updatedAt;
  }
}
